import { ref } from 'vue'

export function useVideoPopup() {
  const isPopupOpen = ref(false)
  const currentVideoSrc = ref('')

  const openPopup = (videoSrc) => {
    currentVideoSrc.value = videoSrc
    isPopupOpen.value = true
  }

  const closePopup = () => {
    isPopupOpen.value = false
    currentVideoSrc.value = ''
  }

  return {
    isPopupOpen,
    currentVideoSrc,
    openPopup,
    closePopup
  }
}
